import { NamespaceLoggerAdapter } from '@fluidx/telemetry';
/**
 * A helper method that returns an implementation of ShareService for containers backed by Sharepoint.
 * @param props
 * @param props.tokenProvider A token provider that can return Sharepoint access tokens
 * @param props.logger Optional logger for telemetry
 * @param props.settingsProvider Optional settings provider for feature flags
 * @param props.appName Optional appName to be encoded to the generated links
 * @param props.bootDocumentInfo ODSP boot document used as share service context when container resolved url is undefined
 * @param props.localization
 * @param props.localization.locale
 * @param props.localization.localeDirection
 * @param props.tenantId
 * @param props.getShareUXTargetElement
 * @param props.getFileContext Optional callback to get file context that will be passed along when sharing/granting access
 */
export function getShareServiceForSharepoint({ tokenProvider, logger, settingsProvider, appName, bootDocumentInfo, localization, tenantId, getShareUXTargetElement, getFileContext }) {
    return import('./SharepointShareService').then((m) => {
        const shareServiceLogger = logger ? new NamespaceLoggerAdapter('ShareService', logger) : undefined;
        return new m.SharepointShareService({
            bootDocumentInfo,
            localization,
            tokenProvider,
            logger: shareServiceLogger,
            settingsProvider,
            appName,
            tenantId,
            getShareUXTargetElement,
            getFileContext
        });
    });
}
//# sourceMappingURL=getShareServiceForSharepoint.js.map